





import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Date extends Vue {}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/components/info/components/date/Date.vue